import { FaFacebook, FaHome, FaLinkedin, FaMailBulk, FaPhone, FaTwitter, FaWhatsapp } from "react-icons/fa"
import "./FooterStyles.css"
import { Link } from "react-router-dom"


export const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <FaHome size={20} style={{color:"fff", marginRight: "2rem" }}/>
                    <div>
                        <p>1, Odo-Uro, Along Old Iyin Road,</p>
                        <p>Ado-Ekiti, Ekiti State, Nigeria.</p>
                    </div>
                </div>
                <div className="phone">
                    <h4><FaPhone size={20} style={{color:"#fff", marginRight: "2rem"}}/> 
                   <Link to="tel:+2347069056472"> +234 7069056472</Link></h4>                    
                </div>
                <div className="phone">
                    <h4><FaWhatsapp size={20} style={{color:"#fff", marginRight: "2rem"}}/> 
                    <Link to="https://wa.me/+2347069056472?text=Hello!%20I%20need%20more%20information%20on%20a%20Projecct." target="_black">+234 7069056472</Link></h4>                    
                </div>
                    <div className="email">
                    <h4><FaMailBulk size={20} style={{color:"#fff", marginRight: "2rem"}}/> 
                    ekreat2016@gmail.com</h4>                    
                </div>
            </div>
            <div className="right">
                <h4>About the Company</h4>
                <p>Ekreat Solution is a forward–thinking Information and Communication Technology (ICT) 
                    service provider dedicated to delivering reliable, innovative, and affordable digital 
                    solutions. see <Link to="./Projects">Projects</Link>.</p>
                <div className="social">
                    <Link to="https://web.facebook.com/ekreat.com.ng" target="_blank"><FaFacebook size={30} style={{color:"#fff", marginRight: "1rem"}}/></Link>
                    <Link to="https://x.com/emjegede" target="_blank"><FaTwitter size={30} style={{color:"#fff", marginRight: "1rem"}}/></Link>
                    <Link to="#" target="_blank"><FaLinkedin size={30} style={{color:"#fff", marginRight: "1rem"}}/></Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer